import { ICON_MAP } from "./iconList";
import * as LucideAll from "lucide-react";

// Lazy-built extended map: includes all valid lucide icons
let _extMap = null;

function getExtMap() {
  if (_extMap) return _extMap;
  _extMap = { ...ICON_MAP };
  // Add all lucide icons not in curated list
  Object.entries(LucideAll).forEach(([name, comp]) => {
    if (/^[A-Z][a-zA-Z0-9]+$/.test(name) && !name.endsWith("Icon") && typeof comp?.render === "function") {
      _extMap[name] = comp;
    }
  });
  return _extMap;
}

/**
 * Resolve an icon name to a React component.
 * Handles names saved with "Lucide" prefix (e.g., "LucideArrowBigRight" → "ArrowBigRight").
 */
export function resolveIcon(iconName) {
  if (!iconName) return null;
  const map = getExtMap();
  // Try exact name first
  if (map[iconName]) return map[iconName];
  // Try stripping "Lucide" prefix (legacy saved icons)
  const stripped = iconName.replace(/^Lucide/, "");
  return map[stripped] || null;
}
